// extracted by mini-css-extract-plugin
export var label = "_kk-2";
export var slideContainer = "_kk-0";
export var slider = "_kk-1";